import utils from './../../utils';
import fetch from './../fetch';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const getSelection = () => {
    return DataGrid.selections;
}

const prefixUrl = 'teacher/teaching/quality/exam/inspect';

const columns = utils.columns([
    {
        key: '$index',
        label: '序号',
        width: 75
    },
    {
        key: 'orgName',
        label: '所属部门',
    },
    {
        key: 'majorName',
        label: '专业',
        width: 100
    },
    {
        key: 'className',
        label: '班级',
        width: 120
    },
    {
        key: 'courseName',
        label: '课程名称',
    },
    {
        key: 'examModality',
        label: '考试形式',
    },
    {
        key: 'propositionCode',
        label: '命题人工号',
    },
    {
        key: 'propositionName',
        label: '命题人姓名',
    },
    {
        key: 'markerCode',
        label: '阅卷人工号',
    },
    {
        key: 'markerName',
        label: '阅卷人姓名',
    },
    {
        key: 'isFit',
        label: '命题范围与大纲要求一致',
        width: 200
    },
    {
        key: 'isModeration',
        label: '题量适中',
    },
    {
        key: 'isSuitable',
        label: '难易适当',
    },
    {
        key: 'isWide',
        label: '知识面覆盖宽',
    },
    {
        key: 'isHave',
        label: '有综合性、提高性题目',
        width: 200
    },
    {
        key: 'isStandard',
        label: '试卷清楚、规范',
        width: 150
    },
    {
        key: 'isNotError',
        label: '试卷无错误',
    },
    {
        key: 'isNormative',
        label: '评分标准细致、规范',
        width: 175
    },
    {
        key: 'isFair',
        label: '阅卷评分公正、无误',
        width: 175
    },
    {
        key: 'isAccuracy',
        label: '试卷分析客观、准确',
        width: 175
    },
    {
        key: 'evalScore',
        label: '评价得分',
    },
    {
        key: 'evalOpinion',
        label: '评价意见',
    },
    {
        key: 'inspectName',
        label: '检查人姓名',
    },
    {
        key: 'evalDate',
        label: '评阅日期',
    },
    {
        key: 'termName',
        label: '所属学期',
    },
    
])

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post(`${prefixUrl}/query?pageNum=${keywords.pageNum}&pageSize=${keywords.pageSize}&order=${keywords.order || ''}&sort=${keywords.sort || ''}`, keywords)
        .then(res => {
            const data = res.payload.data;
            return Object.assign({
                result: data.dataList,
                selects: data.dataList.map(e => {
                    return {
                        value: e.id,
                        checked: false,
                    }
                }),
                checked: false,
                total: data.total,
                pageIndex: data.pageNum,
                pageSize: data.pageSize,
                notify: ([]).length ? '' : '暂无数据...'
            })
        })
}

const remove = (ids) => {
    return fetch.post(`${prefixUrl}/delete`, ids)
        .then(res => {
            if (res.code === 200) {
                return res.payload.data;
            }
        })
}

const getDataById = (id) => {
    return fetch.get(`${prefixUrl}/get/${id}`)
    .then(res => {
        if(res.code === 200) {
            return res.payload.data;
        }
    })
}

const update = (keywords) => {
    return fetch.post(`${prefixUrl}/update`,keywords)
    .then(res => {
        if(res.code === 200) {
            DataGrid.selections = [];
            DataGrid.refresh();
            return res;
        }
    })
}

const queryByStudentName = (params) => {
    return fetch.get(`student/query/by/studentName?studentName=${params.studentName || ''}&limit=${params.limit || undefined}`)
    .then(res => {
        if ( res.code === 200 ) {
            return res.payload.data;
        }
    })
}

const queryByEmployeeName = (params) => {
    return fetch.get(`employee/query/by/employeeName?employeeName=${params.employeeName || ''}&limit=${params.limit || undefined}`)
    .then(res => {
        if ( res.code === 200 ) {
            return res.payload.data;
        }
    })
}

const queryByClassName = (params) => {
    return fetch.get(`classes/query/by/className?className=${params.className || ''}&limit=${params.limit || undefined}`)
    .then(res => {
        if ( res.code === 200 ) {
            return res.payload.data;
        }
    })
}

const queryByCourseName = (params) => {
    return fetch.get(`course/query/by/courseName?courseName=${params.courseName || ''}&limit=${params.limit || undefined}`)
    .then(res => {
        if ( res.code === 200 ) {
            return res.payload.data
        }
    })
}

export default {
    queryByCourseName,
    queryByClassName,
    queryByEmployeeName,
    queryByStudentName,
    update,
    getDataById,
    onSelect,
    setRefresh,
    getSelection,
    columns,
    querySearch,
    remove
}